import React, { useState } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Card } from "@material-ui/core"

interface IUniversityCard {
  img?: any
  name: string
  slug: string
  desc: string
}

const UniversityCard: React.FC<IUniversityCard> = ({ img, name, desc, slug }: IUniversityCard) => {
  const string = desc
  const length = 140
  const trimmedString = string.length > length ? string.substring(0, length - 3) + "..." : string
  const [shadow, setShadow] = useState(0)
  const onMouseOver = () => setShadow(15)
  const onMouseOut = () => setShadow(0)
  return (
    <UniversityCardContainer to={"/universities/" + slug}>
      <StyledCard elevation={shadow} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <ImgContainer>
          <GatsbyImage
            image={img}
            style={{ height: "auto", maxHeight: 220, width: "100%" }}
            imgStyle={{ objectFit: "cover" }}
            //placeholderStyle={{ opacity: 0 }}
            loading={"eager"}
            alt={name}
          />
        </ImgContainer>
        <UniversityInfoBox>
          <UniversityName>{name}</UniversityName>
          <UniversityDesc>{trimmedString}</UniversityDesc>
        </UniversityInfoBox>
      </StyledCard>
    </UniversityCardContainer>
  )
}

export default UniversityCard

export const UniversityCardCarousel: React.FC<IUniversityCard> = ({ img, name, desc, slug }: IUniversityCard) => {
  const string = desc
  const length = 140
  const trimmedString = string.length > length ? string.substring(0, length - 3) + "..." : string
  const [shadow, setShadow] = useState(0)
  const onMouseOver = () => setShadow(15)
  const onMouseOut = () => setShadow(0)
  return (
    <UniversityCarouselCardContainer to={"/universities/" + slug}>
      <StyledCard elevation={shadow} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <ImgContainer>
          <GatsbyImage
            image={img}
            style={{ height: "auto", maxHeight: 220, width: "100%" }}
            imgStyle={{ objectFit: "cover" }}
            //placeholderStyle={{ opacity: 0 }}
            loading={"eager"}
            alt={name}
          />
        </ImgContainer>
        <UniversityInfoBox>
          <UniversityName>{name}</UniversityName>
          <UniversityDesc>{trimmedString}</UniversityDesc>
        </UniversityInfoBox>
      </StyledCard>
    </UniversityCarouselCardContainer>
  )
}

const StyledCard = styled(Card)`
  border-radius: 0px !important;
  /* border: 1px solid red; */
  height: 100%;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    border: 1px solid #e3e3e3;
  }
`

const UniversityCardContainer = styled(Link)`
  border: 1px solid #e3e3e3;

  background-color: #ffffff;
  &:hover {
    text-decoration: none;
  }

  max-width: 365px;
`
const ImgContainer = styled.div`
  display: flex;
  min-height: 218px;
  background-color: white;
  align-items: center;
  justify-content: center;
  z-index: 10;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    min-height: 155px;

    border-top: 1px solid #e3e3e3;
    border-left: 1px solid #e3e3e3;
    border-right: 1px solid #e3e3e3;
  }
`
const UniversityCarouselCardContainer = styled(Link)`
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  min-width: 320px;
  &:hover {
    text-decoration: none;
  }

  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    border: 0px solid #e3e3e3;
    width: 290px !important;
  }
`

const UniversityInfoBox = styled.div`
  padding: 22px 30px;

  height: 200px;
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    height: 165px;
    border-bottom: 1px solid #e3e3e3;
    border-left: 1px solid #e3e3e3;
    border-right: 1px solid #e3e3e3;
  }
`

const UniversityName = styled.p`
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 26px;
  height: 38px;
  margin-bottom: 18px;
  color: black;
  @media (max-width: 768px) {
    font-size: 16px;

    line-height: 21px;
  }
`

const UniversityDesc = styled.p`
  color: #4a4a4a !important;
  font-size: 18px;
  line-height: 28px;
  @media (max-width: 768px) {
    font-size: 14px;

    line-height: 24px;
  }
`
